import styled from 'styled-components'

import Verified from '~/shared/assets/icons/Verified'
import Button from '~/shared/components/buttons/Button'
import theme from '~/shared/styles/theme'

function PasswordChangeCompletedPage() {
  return (
    <Wrapper>
      <Container>
        <MainBox>
          <Title>비밀번호 변경 완료</Title>
          <VerifiedIcon />
        </MainBox>
        <SubText>
          비밀 번호가 변경되었습니다. <br />
          새로운 비밀번호로 로그인해 주세요.
        </SubText>
        <Button $width={171} $height={58} $fontSize={24} $variant="transparent">
          로그인 하기
        </Button>
      </Container>
    </Wrapper>
  )
}

export default PasswordChangeCompletedPage

const Wrapper = styled.section`
  width: 100vw;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  padding-top: ${theme.size.headerHeight}px;
`

const Container = styled.p`
  position: absolute;
  top: 50%;
  left: 30%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 36px;

  margin: auto;

  @media ${theme.device.medium} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    gap: 24px;

    width: 90%;
  }
`

const MainBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;

  @media ${theme.device.medium} {
    gap: 10px;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 60px;
  font-weight: 500;
  line-height: 84px;
  text-align: left;

  @media ${theme.device.medium} {
    font-size: 36px;
    line-height: 50px;
  }
`

const VerifiedIcon = styled(Verified)`
  @media ${theme.device.medium} {
    width: 40px;
    height: 40px;
    font-size: 36px;
  }
`

const SubText = styled.div`
  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 32px;
  line-height: 44px;

  @media ${theme.device.medium} {
    font-size: 21px;
    line-height: 29px;
  }
`
